import { useCallback } from "react";
import { ChevronLeftMinor } from "@shopify/polaris-icons";
import { Button, Layout, Page, Stack } from "@shopify/polaris";
import { useSaveBarSafeNavigate } from "../../../../hooks/useSaveBarSafeNavigate.js";

import { attributes_card_image, stock_card_image } from "../../../../assets/index.js";
import { ACTION_TYPE_ATTRIBUTES, ACTION_TYPE_STOCK } from "../../../../../constants/actionTypes.js";
import ActionCard from "./components/ActionCard.js";
import CreateActionModal from "../../../modals/CreateActionModal/CreateActionModal.js";
import { resetAction } from "../../../../store/features/action.js";
import { useAppDispatch } from "../../../../hooks/redux.js";

const cards = [
  {
    type: ACTION_TYPE_STOCK,
    src: stock_card_image,
    title: "Hide or push down products based on their stock levels",
    description: "Customizable stock levels include low stock, out-of-stock and back-in-stock."
  },
  {
    type: ACTION_TYPE_ATTRIBUTES,
    src: attributes_card_image,
    title: "Hide or push down products based on their attributes",
    description: "Attributes can include missing pictures, descriptions and more."
  }
];

const ChooseAction = () => {
  const navigate = useSaveBarSafeNavigate();
  const dispatch = useAppDispatch();

  const handleBack = useCallback(() => {
    dispatch(resetAction());
    navigate("/dashboard");
  }, []);

  return (
    <Page
      fullWidth
      title="Choose your action"
      additionalMetadata="Pick which action you’d like Stockhide to automatically do for you. We have multiple actions available below."
    >
      <Layout>
        <Layout.Section>
          <Stack>
            {cards.map(({ type, src, title, description }) => (
              <ActionCard
                key={type}
                type={type}
                src={src}
                title={title}
                description={description}
              />
            ))}
          </Stack>
        </Layout.Section>
        <Layout.Section>
          <Button
            icon={ChevronLeftMinor}
            onClick={handleBack}
          >
            Back
          </Button>
        </Layout.Section>
        <CreateActionModal />
      </Layout>
    </Page>

  );
};

export default ChooseAction;
